import { html, rune, View } from 'rune-ts';
import { PlusContent, PlusContentCard } from '../../../../components/cells/PlusContentCard/PlusContentCard';
import klass from './PlusContent.module.scss';
import { SectionTitle } from '@services/MarppleShop/renderApp/components/cells/SectionTitle/SectionTitle';
import { SeeMoreLinkPlugin } from '@services/MarppleShop/renderApp/components/cells/SectionTitle/plugins';
import { makeUtilScreenNavigate } from '@services/MarppleShop/shared/app/navigate.ts';
import { makePlusUrl } from '@services/MarppleShop/shared/util/url.ts';

export type PlusContentProps = {
  plus_crew: {
    domain_name: string;
  };
  contents: PlusContent[];
  is_mobile: boolean;
};

export class MainPlusContentSection extends View<PlusContentProps> {
  protected override template() {
    const is_mobile = !!rune.getSharedData(this)?.is_mobile;

    return html`
      <div class="${klass.container}">
        <div class="${klass.title_wrap}">
          ${new SectionTitle({
            title_props: {
              title: ET('mps2::plus::content'),
              size: this.data.is_mobile ? 'large' : 'xLarge',
            },
            plugins: [
              new SeeMoreLinkPlugin({
                see_more_link: makePlusUrl(this.data.plus_crew.domain_name, `/${ET.lang}/@/todays`),
                navigate: makeUtilScreenNavigate(
                  makePlusUrl(this.data.plus_crew.domain_name, `/${ET.lang}/@/todays`),
                ),
                size: this.data.is_mobile ? 'xSmall' : 'medium',
              }),
            ],
          })}
        </div>
        <div class="${klass.list}">
          ${this.data.contents.map(
            (card) =>
              new PlusContentCard(
                { content: card },
                { without_item: true, is_mobile, klass_name: klass.item },
              ),
          )}
        </div>
      </div>
    `;
  }
}
